<template>
  <div>
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      switchFullscreen
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭">

      <a-spin :spinning="confirmLoading">
        <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
          <a-form-model-item
            prop="name"
            label="模块名称">
            <a-input placeholder="请输入模块名称" v-model="model.name" />
          </a-form-model-item>
          <a-form-model-item
            prop="code"
            label="模块Code">
            <a-input placeholder="请输入模块Code" v-model="model.code" />
          </a-form-model-item>
          <a-form-model-item
            prop="icon"
            label="模块Icon">
            <a-input placeholder="请输入模块Icon" v-model="model.icon" />
          </a-form-model-item>          
          <a-form-model-item
            prop="type"
            label="模型类型">
            <a-select  v-model='model.type' placeholder='请选择' >
              <a-select-option :value='item.value' :key="item.value" v-for="item in typeList">{{item.text}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            v-if="model.type=='2'"
            prop="diseaseName"
            label="所属病种">
            <a-input style="width: 300px" :readOnly="true" placeholder="请选择所属病种" v-model="model.diseaseName" />
            <a-button icon="search" @click="selectDisease"></a-button>
          </a-form-model-item>
          <a-form-model-item
            prop="keyword"
            help="输入关键字后，敲击回车键"
            label="关键字">
            <a-select mode="tags" @change="keywordChange" v-model='model.keywordList' placeholder='请选择' >
              <a-select-option :value='item' :key="item" v-for="item in model.keywordList">{{item}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            prop="description"
            label="描述">
            <a-textarea :rows="4" placeholder="请输入描述" v-model="model.description" />
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
    <disease-select ref="diseaseSelect" @handleSelect="handleDiseaseSelected"></disease-select>
  </div>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import DiseaseSelect from '@views/tempconfig/modules/comp/DiseaseSelect.vue'

  export default {
    name: "TempConfigModuleModal",
    components: { DiseaseSelect },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {
          keywordList:[],
        },
        typeList:[
          {text:'通用模块',value:'1'},
          {text:'专病模块',value:'2'},
        ],
        rules:{
          name:[baseRules.required],
          diseaseName:[baseRules.required],
          type:[baseRules.requiredChange],
        },
        confirmLoading: false,

        url: {
          add: "/tempconfig/tempConfigModule/add",
          edit: "/tempconfig/tempConfigModule/edit",
        },
      }
    },
    created () {
    },
    methods: {
      keywordChange(){
        this.$set(this.model,'keyword',this.model.keywordList.join(','))
      },
      add () {
        this.edit({
          keywordList:[],
        });
      },
      edit (record) {
        this.model = Object.assign({
          keywordList:record.keyword?record.keyword.split(','):[]

        }, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;
            if(formData.type=='1'){
              formData.diseaseCode = ''
              formData.diseaseName = ''
            }
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      selectDisease(){
        this.$refs.diseaseSelect.view()
      },
      handleDiseaseSelected(record){
        this.$set(this.model,'diseaseCode', record.code)
        this.$set(this.model,'diseaseName', record.name)
      }
    }
  }
</script>

<style lang="less" scoped>

</style>